function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import { NODE_TYPE } from './data';
export var isFinectLink = function isFinectLink(link) {
  return ['https://www.finect.com', 'http://www.finect.com', '/'].some(function (test) {
    return link.startsWith(test);
  });
};
export var serializeElement = function serializeElement(element) {
  return {
    id: element.id,
    nodeType: element.nodeType,
    rawAttrs: element.rawAttrs,
    rawTagName: element.rawTagName,
    attributes: element.attributes,
    classList: element.classList ? Array.from(element.classList.values()) : [],
    childNodes: element.childNodes.map(function (childNode) {
      return serializeElement(childNode);
    }),
    text: element.nodeType === NODE_TYPE.TEXT_NODE ? element._rawText : '',
    outerHTML: element.outerHTML
  };
};
export function setDangerousHtml(html, el) {
  if (el === null) return;
  var range = document.createRange();
  range.selectNodeContents(el);
  range.deleteContents();
  el.appendChild(range.createContextualFragment(html));
}
export var getSizeFromURL = function getSizeFromURL(src) {
  var _src$split = src.split('-'),
    _src$split2 = _slicedToArray(_src$split, 3),
    name = _src$split2[0],
    _src$split2$ = _src$split2[1],
    sizeFormat = _src$split2$ === void 0 ? '' : _src$split2$,
    format = _src$split2[2];
  var size = sizeFormat ? Number(sizeFormat.substring(1)) : 0;
  if (size === 0) return null;
  if (sizeFormat.indexOf('w') === 0) {
    return {
      width: size,
      height: Math.round(size * 9 / 16)
    };
  }
  if (sizeFormat.indexOf('h') === 0) {
    return {
      height: size,
      width: Math.round(size * 16 / 9)
    };
  }
  return null;
};